import i18n from '@/i18n';
import { NavigationGuard } from 'vue-router';

/**
 * If the route has a titleKey, set the document title to the app name and the titleKey.
 * @param to - The target Route Object being navigated to.
 * @param from - The route that the user is currently on.
 * @param next - Function
 * @returns The next() function.
 */
const TITLE_GUARD: NavigationGuard = async (to, from, next) => {
   if (to.meta.titleKey) {
      document.title = `${i18n.global.t('app-name')} - ${i18n.global.t(to.meta.titleKey as string, 2)}`;
   }

   return next();
};

export default TITLE_GUARD;
